import { useRef, useState } from "react";
import { Table } from "./Table";
import { IPermissionProps } from "../../models/Login";
import { Toast } from "primereact/toast";

export interface IModal {
    singleData: any,
    open: boolean
}

export const AllocationList = (permissions: IPermissionProps) => {
    const [modal, setModal] = useState({ singleData: {}, open: false } as IModal);
    const [reload, setReload] = useState(false);
    const toast = useRef<any>(null);

    const hideDialog = () => {
        setModal({ singleData: "", open: false });
    };

    return (
        <>
            <Table permissions={permissions} setModal={setModal} toast={toast} reload={reload} setReload={setReload}></Table>
            <Toast ref={toast} />
        </>
    );
}